import React from 'react'

function customer_icon() {
  return (
    <>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user" _ngcontent-led-c54="">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2">
            </path><circle cx="12" cy="7" r="4"></circle>
        </svg>
    </>
  )
}

export default customer_icon